import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Quote, Star } from "lucide-react";

const Initial = ({ name }) => {
  const ch = (name || "·").trim().charAt(0).toUpperCase();
  return (
    <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#D4AF37]/40 to-[#4B2E83]/40 border border-white/10 flex items-center justify-center serif text-xl text-[#D4AF37]">
      {ch}
    </div>
  );
};

const TestimonialsSection = ({ programKey, accent = "#D4AF37", language = "de" }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get(`/testimonials?program_key=${encodeURIComponent(programKey)}&language=${language}`)
      .then((r) => setItems(r.data || []))
      .catch(() => setItems([]));
  }, [programKey, language]);

  if (!items.length) return null;

  return (
    <section className="py-24 bg-[#040814] relative overflow-hidden" data-testid="programme-testimonials">
      {/* subtle aurora */}
      <div className="absolute inset-0 pointer-events-none opacity-50"
        style={{
          background: `radial-gradient(circle at 20% 30%, ${accent}15, transparent 55%), radial-gradient(circle at 80% 70%, rgba(75,46,131,0.15), transparent 55%)`,
        }}
      />
      <div className="relative max-w-[1200px] mx-auto px-6 lg:px-12">
        <div className="overline mb-3" style={{ color: accent }}>{language === "en" ? "Voices" : "Stimmen"}</div>
        <h2 className="headline-xl text-4xl md:text-6xl max-w-3xl">{language === "en" ? "From those who walked this path." : "Von denen, die diesen Weg gegangen sind."}</h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
          {items.slice(0, 6).map((t, i) => (
            <figure
              key={t.id || i}
              className="relative rounded-2xl border border-white/8 bg-[#0E1A30]/70 backdrop-blur p-7 hover:border-white/20 transition group"
              data-testid={`testimonial-${i}`}
            >
              <Quote size={22} className="absolute top-5 right-5 opacity-30 group-hover:opacity-60 transition" style={{ color: accent }} />
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating || 5 }).map((_, k) => (
                  <Star key={k} size={12} className="fill-current" style={{ color: accent }} />
                ))}
              </div>
              <blockquote className="serif text-lg leading-relaxed text-white/85 mb-6">
                <span className="italic">&bdquo;</span>{t.quote}<span className="italic">&ldquo;</span>
              </blockquote>
              <figcaption className="flex items-center gap-3 pt-4 border-t border-white/5">
                {t.photo_url
                  ? <img src={t.photo_url} alt="" className="w-12 h-12 rounded-full object-cover border border-white/10" />
                  : <Initial name={t.name} />}
                <div>
                  <div className="serif text-base">{t.name}</div>
                  <div className="text-xs uppercase tracking-widest text-white/40">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
